<div class="flex w-full flex-nowrap items-center justify-end gap-3 px-1 py-[14px] text-[13px] text-[#555]">
  @if (showPageSize()) {
    <span class="min-w-0">{{ 'Itens por página' | transloco }}:</span>

    <span class="relative w-[86px] flex-none">
      <button
        type="button"
        class="relative flex h-[30px] w-full cursor-pointer items-center rounded-[8px] border border-[#e4e7ea] bg-white pl-2.5 pr-7 text-left text-sm text-[#0d122f] aria-expanded:border-primary disabled:cursor-default disabled:bg-[#f4f5f7] disabled:opacity-[.45]"
        z-dropdown
        aria-haspopup="listbox"
        [zDropdownMenu]="pageSizeMenu"
        [zMatchTriggerWidth]="true"
        zPlacement="below"
        [attr.aria-label]="'Itens por página' | transloco"
        [disabled]="loading() || disabled()"
        [svcTestId]="testIdPrefix() + '__btn--paginate-size'"
      >
        <span class="truncate">{{ pageSize() }}</span>
        <ng-icon
          name="svcChevDown"
          class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-[#8a90a6] icon-size-4"
          aria-hidden="true"
        ></ng-icon>
      </button>

      <z-dropdown-menu-content
        #pageSizeMenu
        class="max-h-60 w-full min-w-0 overflow-y-auto rounded-[10px] border border-[#e6e8ee] bg-white p-1 shadow-[0_12px_30px_rgba(13,18,47,.16)]"
      >
        @for (option of pageSizeOptions(); track option) {
          <button
            z-dropdown-menu-item
            type="button"
            role="option"
            [class]="option === pageSize() ? selectedOptionClass : optionClass"
            [attr.aria-selected]="option === pageSize()"
            [svcTestId]="testIdPrefix() + '__menu--paginate-size-' + option"
            (click)="optionChanged(option)"
          >
            {{ option }}
            @if (option === pageSize()) {
              <ng-icon
                name="svcCheckC"
                class="flex-none icon-size-[18px]"
                aria-hidden="true"
              ></ng-icon>
            }
          </button>
        }
      </z-dropdown-menu-content>
    </span>
  }

  <!-- Range connector: the key stays the pt-BR term `de`; Multilingual translates it to "from" in English (it is the preposition
       of "De:"), so English renders the literal "of" until the content team registers a range term (product decision 2026-09-10). -->
  <p class="min-w-0">{{ startFrom() }} - {{ endFrom() }} {{ isEnglish() ? 'of' : ('de' | transloco) }} {{ from() }}</p>

  <button
    type="button"
    class="inline-flex size-[30px] flex-none cursor-pointer items-center justify-center rounded-md border-0 bg-transparent text-primary disabled:cursor-default disabled:text-[#c2c2c2]"
    [attr.aria-label]="'Anterior' | transloco"
    [disabled]="loading() || disabled() || !hasPrevPage()"
    [svcTestId]="testIdPrefix() + '__btn--paginate-prev'"
    (click)="prevPage()"
  >
    <ng-icon
      name="svcChevLeft"
      class="icon-size-[18px]"
      aria-hidden="true"
    ></ng-icon>
  </button>

  <button
    type="button"
    class="inline-flex size-[30px] flex-none cursor-pointer items-center justify-center rounded-md border-0 bg-transparent text-primary disabled:cursor-default disabled:text-[#c2c2c2]"
    [attr.aria-label]="'Próximo' | transloco"
    [disabled]="loading() || disabled() || !hasNextPage()"
    [svcTestId]="testIdPrefix() + '__btn--paginate-next'"
    (click)="nextPage()"
  >
    <ng-icon
      name="svcChevRight"
      class="icon-size-[18px]"
      aria-hidden="true"
    ></ng-icon>
  </button>
</div>
